import React from 'react';
import '../css/Refill.css';
import Review from './review';

const benefits = [
  {
    title: "Work Smarter, Not Harder",
    description: "Automated messaging and online checkout reduce staffing time spent on calls and manual check‑outs, allowing our team to focus on patient care.",
    icon: "🤖"
  },
  {
    title: "Reduce Errors & Wait Times",
    description: "Efficient, predictable workflows mean faster pickup, lower risk of dispensing mistakes, and happier patients.",
    icon: "⏱️"
  },
  {
    title: "Integrated, Seamless System",
    description: "Our management software (e.g. BestRx) syncs directly with NimbleRx—no retyping patient or prescription data.",
    icon: "🔗"
  },
  {
    title: "Unlock Additional Revenue",
    description: "By enabling remote payments, OTC recommendations, and signature capture, NimbleRx helps grow refill and ancillary sales—even after hours.",
    icon: "💸"
  },
  {
    title: "Convenient for Patients",
    description: "Patients can handle refills and payments online, skip in‑person lines, and opt for home delivery or quick pickup.",
    icon: "🏠"
  }
];

function RefillMadeEasy() {
  return (
    <div className="refill-page">
      <div className="refill-banner">
        <img
          src={'/img_11.634Z.png'}
          alt="Refill Banner"
          className="refill-banner-img"
        />
        <div className="refill-banner-overlay"></div>
        <div className="refill-banner-content">
          <h1>Refills Made Easy with NimbleRx</h1>
        </div>
      </div>

      <header className="refill-header">
        <h2>Why Our Pharmacy Loves NimbleRx</h2>
        <p>
          NimbleRx is a HIPAA‑compliant digital platform that helps pharmacies streamline their operations—handling prescription ordering, refills, payments, messaging, and delivery through a user-friendly app or text interface. It integrates smoothly with systems like BestRx to save your pharmacy time and enhance patient care.
        </p>
      </header>

      <div className="refill-cards">
        {benefits.map((benefit, idx) => (
          <div className="refill-card" key={idx}>
            <div className="refill-icon">{benefit.icon}</div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>

      <div className="refill-benefits-card">
        <h4>Real-World Impact</h4>
        <ul>
          <li>
            NimbleRx’s same-day delivery service has helped pharmacies reach higher patient satisfaction (NPS of ~75) and improved business margins by encouraging repeat orders and frequent purchases.
          </li>
          <li>
            One independent pharmacy reported nearly 50% of their customers switched to using NimbleRx for prescription handling, boosting convenience and operational reliability.
          </li>
        </ul>
      </div>
{/** 
      <div className="refill-quotes-card">
        <h4>Voices from the Field</h4>
        <blockquote>
          “It was pretty convenient … patients could pay for their scripts and not have to wait in long lines … literally just walk up, give their name/DOB and the transaction would be over.”
        </blockquote>
        <blockquote>
          “We tried Nimble for a couple of years … we weren’t impressed … rural context and older patient base may affect results.”
        </blockquote>
      </div>
      */}

      <div className="refill-info-card">
        <h4>Why It Matters</h4>
        <p>
          In today’s fast-paced healthcare environment, NimbleRx gives our pharmacy the edge—improving operational efficiency, patient satisfaction, and revenue opportunities without sacrificing personal care.
        </p>
        <h4>Interested? Let Us Help You</h4>
        <p>
          Want to see NimbleRx in action or learn how we’ve tailored it for our pharmacy? <a href="/contact">Contact us</a>—we’re happy to share how it’s working for our patients and how it can work for you.
        </p>
      </div>
       <Review/>
    </div>
  );
}

export default RefillMadeEasy;